import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React from 'react';
import { PopoverCell } from '../components/constructed';

export const truncateWithPopover = (text: string, maxLength: number = 30) => {
    if (text.length <= maxLength) {
        return <Text type={'b200'}>{text}</Text>;
    }

    return (
        <Row>
            <Text type={'b200'}>{text.substring(0, maxLength)}</Text>
            <PopoverCell buttonLable={'…'}>
                <Text type={'b200'}>{text}</Text>
            </PopoverCell>
        </Row>
    );
};

// TODO Add sanitization in HDSS - OE item https://issues.amazon.com/issues/Bender-16832
// ISO-8859-1 sanitization for filenames
export const sanitizeFilenameISO88591 = (filename: string): string => {
    return (
        filename
            // Normalize Unicode characters to their closest ASCII equivalents
            .normalize('NFKD')
            // Keep only ISO-8859-1 printable characters (0x20-0xFF)
            .replace(/[^\x20-\xFF]/g, '')
            // Replace any remaining problematic characters with safe alternatives
            .replace(/[<>:"/\\|?*]/g, '_')
    ); // Common filename-unsafe characters
};

export const toFamilyTranslationKey = (family: string): string => `common:family-${family.replaceAll(' ', '-')}`;
